import React from "react";
import { Dialog } from "../../dialog";
import { Container, Icon, Image } from "../../../components";
import { useI18n } from "../../../lib/i18n/i18n_provider";
import { TextLink } from "../../text_link";
import { useWeworkPostPurchaseFeatureFlag } from "../../../core/splitio";
import { Text } from "../../text";
import { Spacer } from "../../spacer";
import { Button } from "../../button";

export interface PostPurchaseModalProps {
  onRequestClose: () => void;
  isOpen: boolean;
}

const weWorkPostPurchaseModalEN = (
  <Container maxWidth={800} padding={5}>
    <div
      style={{ display: "flex", alignItems: "center", justifyItems: "center" }}
    >
      <div style={{ maxWidth: "50%", padding: "10px" }}>
        <Image
          src="https://meet-production.s3.us-west-1.amazonaws.com/images/wework/post_purchase.jpg"
          alt="wework_post_purchase"
        />
      </div>
      <div
        style={{
          maxWidth: "50%",
          padding: "10px",
        }}
      >
        <Text weight="bold">Special benefits for Munier refreshments</Text>
        <Spacer />
        <Text size="sm">
          Interested in ordering catering or refreshments for your meeting?
        </Text>
        <Spacer />
        <Text size="sm">
          Discover exclusive promo codes for WeWork guests on Munier’s products.
        </Text>
        <Spacer size={20} />
        <TextLink href="https://wework.co.il/munier" external={true}>
          <Button
            title="Order now"
            override={{
              button: {
                style: {
                  padding: "10px 25px",
                },
              },
            }}
          />
        </TextLink>
      </div>
    </div>
  </Container>
);

const weWorkPostPurchaseModalHE = (
  <Container maxWidth={800} padding={5}>
    <div
      style={{ display: "flex", alignItems: "center", justifyItems: "center" }}
    >
      <div style={{ maxWidth: "50%", padding: "10px" }}>
        <Image
          src="https://meet-production.s3.us-west-1.amazonaws.com/images/wework/post_purchase.jpg"
          alt="wework_post_purchase"
        />
      </div>
      <div
        style={{
          maxWidth: "50%",
          padding: "10px",
        }}
      >
        <Text weight="bold">הטבות מיוחדות למגשי האירוח של מונייר</Text>
        <Spacer />
        <Text size="sm">מעוניינים להזמין מגשי אירוח או כיבוד לפגישה?</Text>
        <Spacer />
        <Text size="sm">
          לחצו על הלינק לקבלת הטבות בלעדיות לאורחים של WeWork.
        </Text>
        <Spacer size={20} />
        <TextLink href="https://wework.co.il/munier" external={true}>
          <Button
            title="להזמנות"
            override={{
              button: {
                style: {
                  padding: "10px 25px",
                },
              },
            }}
          />
        </TextLink>
      </div>
    </div>
  </Container>
);

export function PostPurchaseModal(props: PostPurchaseModalProps) {
  const { onRequestClose, isOpen } = props;

  const { locale } = useI18n();

  if (!useWeworkPostPurchaseFeatureFlag()) {
    return <></>;
  }

  return (
    <Dialog isOpen={isOpen} onRequestClose={onRequestClose}>
      <button
        className="close-button"
        onClick={onRequestClose}
        style={{
          position: "absolute",
          zIndex: 2,
          right: locale.baseLanguageTag === "en" ? 0 : "auto",
          left: locale.baseLanguageTag !== "en" ? 0 : "auto",
          cursor: "pointer",
        }}
      >
        <Icon name="x" />
      </button>
      {locale.baseLanguageTag === "en"
        ? weWorkPostPurchaseModalEN
        : weWorkPostPurchaseModalHE}
    </Dialog>
  );
}
